export default "__VITE_ASSET__CXeC1FCS__"